import { useTranslation } from "react-i18next";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const HINT = {
  geofence: (c, t) => t("readiness.geofenceHint", { distance: Math.round(c.distance_m), radius: c.radius_m }),
  time: (c, t) => t("readiness.timeHint", { late: c.late_minutes, allowed: c.allowed_minutes }),
  compensation: (c, t) => t("readiness.compensationHint", { minutes: c.remaining_minutes }),
  early_window: (c, t) => t("readiness.early_windowHint", { opens: c.opens_local, minutes: c.minutes_left }),
  tokens: (c, t) => t("readiness.tokensHint", { balance: c.balance }),
};

// Live pre-flight checklist: the capture button stays locked until every row is green.
export const ReadinessChecklist = ({ readiness, loading }) => {
  const { t } = useTranslation();

  if (loading || !readiness) {
    return (
      <p className="mt-4 flex items-center justify-center gap-2 text-xs font-bold text-slate-400" data-testid="readiness-loading">
        <Loader2 className="h-4 w-4 animate-spin" /> {t("readiness.checking")}
      </p>
    );
  }

  return (
    <ul className="mt-4 grid gap-1.5" data-testid="readiness-checklist">
      {readiness.checks.map((c) => (
        <li
          key={c.key}
          data-testid={`readiness-${c.key}`}
          className={`flex items-center justify-between gap-2 rounded-2xl px-3 py-2 text-[11px] font-bold ${
            c.passed ? "bg-emerald-500/10 text-emerald-500" : "bg-red-500/10 text-red-400"
          }`}
        >
          <span className="flex items-center gap-2">
            {c.passed ? <CheckCircle2 className="h-4 w-4" /> : <XCircle className="h-4 w-4" />}
            {t(`readiness.${c.key}`)}
          </span>
          {HINT[c.key] ? (
            <span className="font-mono text-[10px] opacity-80" dir="ltr">
              {HINT[c.key](c, t)}
            </span>
          ) : null}
        </li>
      ))}
    </ul>
  );
};
